<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/stores/user'
import { useDialer } from '@/composables/useDialer'
import BaseButton from '@/components/BaseButton.vue'

defineProps<{
  errorMessage: string | null
  disabled: boolean
}>()
const emit = defineEmits(['submit'])

const { fname, lname, phone_number, caller_id, caller_ids } = useDialer()
const { user } = storeToRefs(useUserStore())

// Bootstrap 3 .form-control metrics (extracted form: 4px radius)
const formControl =
  'block w-full h-[34px] px-[12px] py-[6px] text-[14px] leading-[1.42857143] text-[#555] ' +
  'bg-white border border-[#ccc] rounded-[4px] shadow-[inset_0_1px_1px_rgba(0,0,0,0.075)] ' +
  'transition-[border-color,box-shadow] duration-150 ease-in-out focus:border-[#66afe9] ' +
  'focus:outline-none focus:shadow-[inset_0_1px_1px_rgba(0,0,0,0.075),0_0_8px_rgba(102,175,233,0.6)]'
</script>

<template>
  <h3 class="text-center mt-0 mb-[30px]">New Call</h3>

  <form role="form" class="px-[30px] h-[400px]" @submit.prevent="emit('submit')">
    <div v-if="errorMessage" class="block mt-0 mb-[10px] text-center text-[#a94442]">
      <strong>{{ errorMessage }} </strong>
    </div>

    <div class="flex flex-wrap -mx-[15px]">
      <div class="w-1/2 px-[15px]">
        <div class="mb-[15px]">
          <label for="name" class="inline-block max-w-full mb-[5px] font-bold">First Name</label>

          <input
            id="fname"
            v-model="fname"
            class="text-[18px]! p-[22px_10px]!"
            type="text"
            :class="formControl"
          />
        </div>
      </div>

      <div class="w-1/2 px-[15px]">
        <div class="mb-[15px]">
          <label for="name" class="inline-block max-w-full mb-[5px] font-bold">Last Name</label>

          <input
            id="lname"
            v-model="lname"
            class="text-[18px]! p-[22px_10px]!"
            type="text"
            :class="formControl"
          />
        </div>
      </div>
    </div>

    <div class="flow-root">
      <div>
        <div class="mb-[15px]">
          <label for="name" class="inline-block max-w-full mb-[5px] font-bold">Phone Number</label>
          <div class="flow-root">
            <vue-tel-input
              v-model="phone_number"
              class="bg-white [&_input]:border-none! [&_input]:block! [&_input]:w-full! [&_input]:text-[18px]! [&_input]:pt-[10px]! [&_input]:pr-[10px]! [&_input]:pb-[10px]! [&_input]:pl-[5px]!"
              :default-country="user?.country_code"
              :show-dial-code="true"
              :onlyCountries="user?.account?.countries"
            />
          </div>
        </div>
      </div>
    </div>

    <div v-if="caller_ids.length > 0" class="flow-root">
      <div>
        <div class="mb-[15px]">
          <div class="flex flex-col items-center justify-center">
            <label for="name" class="max-w-full mb-[5px] font-bold flex items-center"
              >Caller ID</label
            >
            <div class="flex items-center justify-center">
              <i class="material-icons float-left text-[#073b4c] text-[16px]! mr-[2px]">phone</i>
              <select
                v-model="caller_id"
                class="border-none bg-transparent shadow-none inline-block"
                :class="[caller_id === null ? 'w-[70px]' : '']"
              >
                <option :value="null">Default</option>
                <option v-for="option in caller_ids" :key="option.id" :value="option.id">
                  {{
                    (option.name ?? '').length > 40
                      ? (option.name ?? '').substring(0, 40) + '...'
                      : (option.name ?? '')
                  }}:
                  {{ option.phone_number_formatted }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="flow-root mt-[20px] mb-0">
      <BaseButton
        id="submit"
        type="submit"
        variant="primary"
        class="float-right p-[10px_20px]! rounded-[2px]! border-none!"
        :disabled="disabled"
      >
        Call Now
      </BaseButton>
    </div>
  </form>
</template>
